import React from 'react';
import styled from 'styled-components';
import { ENABLE_SIDENAV_MENU, PATH_REDEEM_CODE } from '../constants';
import { Link } from 'react-router-dom';
import cssVars from '../../../css/css-variables';
import { bool } from 'prop-types';

const RedeemCode = styled(Link)`
  display: flex;
  width: 100%;
  background: white;
  color: black;
  border: 2px solid black;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: 8px 4px;
  max-width: 127px;
  margin: ${({dropdown, isSideNav}) => dropdown || isSideNav ? '0' : ENABLE_SIDENAV_MENU ? '0.833em 0' : '0.833em 1.667em'}};
  width: ${({dropdown}) => dropdown ? 'none' : 'auto'};
  font-size: ${({dropdown}) => dropdown ? '14px' : '16px'};


  @media screen and (max-width: 720px) {
    margin: 12px 0;
  }

  :hover {
    outline: 1px solid black;
  }

  :active {
    outline: 1px solid ${cssVars.colors.RedeemActive};
  }
`;

export const RedeemButton = (props) => {
  return (
    <RedeemCode
      id="redeem_code_link"
      to={PATH_REDEEM_CODE}
      data-qa-hook="redeemCode.link"
      title="Redeem Code"
      {...props}
    >
      Redeem Code
    </RedeemCode>
  );
};

RedeemButton.propTypes = {
  dropdown: bool
};
